import React from 'react'

export default function InputCnpj({
  value,
  onChange,
  label,
  labelColor = '#14B0BF',
  width = '100%',
  marginTop = 20,
  disabled = false,
}) {
  const styles = {
    container: {
      textAlign: 'left',
      marginTop,
    },
    label: {
      fontSize: '0.8rem',
      color: labelColor,
      display: 'block',
    },
    input: {
      width,
      outline: 'none',
      border: '1px solid  #F1F1F1',
      borderRadius: 3,
      height: 30,
      marginTop: 3,
      padding: 10,
    },
  }

  // CNPJ: 12 primeiros = alfanumérico, 2 últimos = dígitos
  const normalizeCnpj = raw => {
    if (!raw) {
      return { cleaned: '', formatted: '' }
    }

    // remove tudo que não for letra ou número e deixa MAIÚSCULO
    const alnum = raw.replace(/[^0-9a-zA-Z]/g, '').toUpperCase()

    // 12 primeiros podem ser letra/número
    const head = alnum.slice(0, 12)

    // posições 13 e 14: só dígitos
    const tailRaw = alnum.slice(12, 14)
    const tailDigits = tailRaw.replace(/\D/g, '').slice(0, 2)

    const cleaned = (head + tailDigits).slice(0, 14)

    // aplica máscara XX.XXX.XXX/XXXX-XX
    let v = cleaned
    if (v.length > 2) v = v.slice(0, 2) + '.' + v.slice(2)
    if (v.length > 6) v = v.slice(0, 6) + '.' + v.slice(6)
    if (v.length > 10) v = v.slice(0, 10) + '/' + v.slice(10)
    if (v.length > 15) v = v.slice(0, 15) + '-' + v.slice(15)

    return { cleaned, formatted: v }
  }

  const { formatted } = normalizeCnpj(value || '')

  const handleChange = e => {
    const inputValue = e.target.value || ''
    const { cleaned, formatted } = normalizeCnpj(inputValue)

    if (onChange) {
      onChange({ value: cleaned, formattedValue: formatted })
    }
  }

  return (
    <div style={styles.container}>
      <label style={styles.label} htmlFor="myInput">
        {label}
      </label>
      <input style={styles.input} disabled={disabled} value={formatted} onChange={handleChange} />
    </div>
  )
}
